import { API_BASE_URL_ENV } from "../jsx/common/common";
import http from "./HttpService";
import { getJwt } from "./AuthService";

const apiDropdownEndpoint = API_BASE_URL_ENV() + "/admin/settings/dropdown";
const apiUploadImagesEndpoint = API_BASE_URL_ENV() + "/files/uploadFile";
const apiUploadMultiImagesEndpoint = API_BASE_URL_ENV() + "/upload/multiple";
const apiUploadVideosEndpoint = API_BASE_URL_ENV() + "/upload/videos";
const apiUploadMultiVideosEndpoint =
	API_BASE_URL_ENV() + "/upload/videos/multiple";

export default class BaseService {
	apiEndpoint;

	constructor(apiEndPoint) {
		http.setJwt(getJwt());
		this.apiEndpoint = apiEndPoint;
	}

	entityUrl(params = []) {
		return `${this.apiEndpoint}/${params.join("/")}`;
	}

	dropDownUrl(model) {
		return `${apiDropdownEndpoint}/${model}`;
	}

	getList(params) {
		if (params) {
			return http.get(this.apiEndpoint, { params });
		} else {
			return http.get(this.apiEndpoint);
		}
	}

	find(id, params) {
		return http.get(this.entityUrl([id]), { params });
	}

	create(data) {
		return http.post(this.apiEndpoint, data);
	}

	update(id, data) {
		const body = { ...data };
		return http.put(this.entityUrl([id]), body);
	}

	toggleStatus(model, id, params = []) {
		return http.get(this.entityUrl(["toggle-activation", model, id]), {
			params,
		});
	}

	getDropDown(model, params = []) {
		return http.get(this.dropDownUrl(model), { params });
	}

	remove(id, data) {
		if (data || data?.isDeleted) {
			return http.delete(this.entityUrl([id]), { data });
		}

		return http.delete(this.entityUrl([id]));
	}

	delete(data) {
		return http.delete(this.apiEndpoint, data);
	}

	postUpload(file) {
		const formData = new FormData();
		formData.append("img", file);
		return http.post(apiUploadImagesEndpoint, formData);
	}
	postUploadMulti(file) {
		const formData = new FormData();
		file?.map((res) => formData.append("files", res));
		return http.post(apiUploadMultiImagesEndpoint, formData);
	}
	postUploadVideo(file) {
		const formData = new FormData();
		formData.append("video", file);
		return http.post(apiUploadVideosEndpoint, formData);
	}
	postUploadVideos(file) {
		const formData = new FormData();
		file?.map((res) => formData.append("files", res));
		return http.post(apiUploadMultiVideosEndpoint, formData);
	}

	uploadSheet(data) {
		return http.post(`${this.apiEndpoint}/sheet`, data);
	}
}
